angular.module('wbDashboard').controller('ProfileDocumentsControllerAurea',
    ['$scope', '$q', '$filter', '$uibModal', '$timeout', 'User', 'Message', 'NgTableParams',
function ($scope, $q, $filter, $uibModal, $timeout, User, Message, NgTableParams) {

    $scope.documentData = {};

    $scope.year = new Date().getFullYear();
    $scope.lastYear = $scope.year - 1;

    User.retrieveDocuments();
    User.retrieveProspectusLinks();
    $scope.$watchGroup( [User.getDocuments, function() {return User.getProspectusLinks();}], function (data) {
        var [documents, prospectuses] = data;

        if (!$scope.documentData.tableParams) {

            $scope.documentData.tableParams = new NgTableParams({
                count: 10,
                sorting: { date: "desc"}
            }, {
                filterOptions: { filterFilterName: "multiDocTypeFilter" },
                counts: [],
                // determines the pager buttons (left set of buttons in demo)
                paginationMaxBlocks: 7,
                paginationMinBlocks: 0,
                dataset:[{
                    type: "Please Wait",
                    name: "Loading"
                }]
            });

            if ($scope.$stateParams.type === "taxes") {
                $scope.documentData.tableParams.filter().type = "Tax Statements";
            } else if ($scope.$stateParams.type === "agreements") {
                $scope.documentData.tableParams.filter().type = "Agreements";
            }
        }

        if (documents && prospectuses) {
            //update dataset config rather than creating new NgTableParams
            $scope.documentData.tableParams.settings({
                dataset : $scope.formatDocData(documents, prospectuses)
            });
        }
    });

    $scope.downloadSecure = function (key, filename) {
        User.getDocumentUrl(key).then(function (response) {
            // var host = Request.defaults.host;
            // $scope.downloadUrl = host + response.data.response.url;
            $scope.downloadUrl = response.data.response.s3url;
            $scope.downloadFilename = filename;

            var modalInstance = $uibModal.open({
                templateUrl: "modal-secure-download.tpl.html", //id of script tag in template
                scope: $scope,
                size: 'md',
                windowClass: 'confirm-modal secure-download-modal'
            });
            modalInstance.result.catch(angular.noop).finally(function() {
                $timeout(function() {
                    $scope.downloadUrl = null;
                    $scope.downloadFilename = null;
                });
            });

        });
    };

    $scope.options.docType = [
        'All Documents',
        // 'Agreements',
        'Trade Confirmations',
        'Monthly Statements',
        // 'Tax Statements',
        'ETF Prospectuses'
    ];

    $scope.formatDocData = function (documents, prospectuses) {
        var dataDocs = [];

        var tests = {
            agreement: new RegExp("(.*Agreement.*|.*ADV.*|.*Terms.*)"),
            trade: new RegExp("^Trade.*"),
            monthly: new RegExp("^Monthly.*"),
            tax: new RegExp("(^Tax.*|.*\.1099\.pdf|.*\.8949\.pdf|.*\.TXF\.txf|.*Tax.*)")
        };


        angular.forEach(documents, function(doc) {
            var data = {};
            var tempDate = null;
            if (doc.file_at) {
                tempDate = doc.file_at.replace(" ","T");
            } else {
                tempDate = doc.created_at.replace(" ","T");
            }
            data.date = new Date(tempDate);
            data.name = doc.name;
            data.url = doc.downloadUrl;
            data.key = doc.key ? doc.key : false;

            switch (true) {
                case tests.agreement.test(doc.name) :
                    data.type = "Agreements";
                    break;
                case tests.trade.test(doc.name) :
                    data.type = "Trade Confirmations";
                    break;
                case tests.monthly.test(doc.name) :
                    data.type = "Monthly Statements";
                    break;
                case tests.tax.test(doc.name) :
                    data.type = "Tax Statements";
                    break;
            }
            dataDocs.push(data);
        });

        angular.forEach(prospectuses, function(p) {
            var data = {};
            data.date = new Date(p.first_acquired.replace(" ","T"));
            data.name = p.ticker + ' - ' + p.name;
            data.url = p.link;
            data.key = false;
            data.type = "ETF Prospectuses";

            dataDocs.push(data);
        });

        return dataDocs;

    };

}]).filter("multiDocTypeFilter", function() {
    return function(data, typeCriteria){
        return (data || []).filter(function(item) {
            return typeCriteria.type.indexOf(item.type) !== -1 || typeCriteria.type == "All Documents";
        });
    };
});
